"use client";

import { useEffect, useState } from "react";
import { useLocale } from "next-intl";

function formatTime(date: Date, locale: string): string {
  return new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(date);
}

export function LiveClock() {
  const locale = useLocale();
  const [time, setTime] = useState(() => formatTime(new Date(), locale));

  useEffect(() => {
    const update = () => setTime(formatTime(new Date(), locale));
    update();
    const id = setInterval(update, 1000);
    return () => clearInterval(id);
  }, [locale]);

  return <span className="font-mono shrink-0">{time}</span>;
}
